<template>
    <div class="container">
        <div class="mian">
            <div class="box">
                <div class="title">万顺代驾兑换码</div>
                <div class="inputBox">
                    <input type="text" v-model="verifyCode" name="verifyCode" placeholder="请输入您的兑换码" id="" />
                </div>
                <div class="btn" @click="exchange">兑换</div>
            </div>
        </div>
        <div class="rule">
            <p class="title">活动规则</p>
            <ul class="rule_text">
                <div>兑换规则及使用要求：</div>
                <li>
                   1、每个兑换码仅可兑换一次，兑换成功的优惠券仅限代驾订单使用。
                </li>
                <li>
                    2、兑换方法：复制兑换码→个人中心→我的万顺宝→兑换码→输入兑换码→兑换成功。
                </li>
                <li>3、优惠券查看：个人中心→我的万顺宝→优惠券。</li>
                <li>4、优惠券有效期依据券说明，过期自动失效作废。</li>
                <li>
                    5、优惠券不可提现、不可转让、不可出售、不退换，抵扣部分的金额不开具发票。 
                </li>
                <li>
                    6、仅限在线支付时使用，不同类型的优惠券使用限制条件不同，每笔订单仅限使用一张优惠券。
                </li>
                <li>7、虚拟号不参加活动；</li>
                <li>
                    8、对于以不正当方式参与活动的用户，包括但不限于恶意刷量，恶意下单，恶意注册，利用程序漏洞等，万顺叫车有权在不事先通知的情况下取消其参与活动资格、收回相应奖励或追责。
                </li>
                <li>
                    9、在法律允许的范围内，万顺叫车如因市场、运营等实际情况，需要对本活动规则作变动时，将通过官方APP、网站等方式予以公告公布或通知。
                </li>
                <li>10、本活动与Apple Inc无关；</li>
                <li>11、本活动最终解释权归万顺叫车平台所有。</li>
                <li>12、未尽事宜欢迎致电客服咨询，电话：4006424888。</li>
            </ul>
        </div>
        <div class="delog" v-if="delogIS">
            <div class="delogMain">
                <div class="delogtitle">{{ delogtitle }}</div>
                <div class="dect">{{ delogdect }}</div>
                <div class="delogBnt" @click="close">确定</div>
            </div>
        </div>
    </div>
</template>

<script>
import { getCouponCode } from '@/apis/order/order';
import mobileType from '@/utils/mobileType';
    export default {
        data() {
            return {
                params: {
                    areaCode: "",
                    cityCode: "",
                    channel: "10600003",
                    // deviceId: util.getUUID(),
                    platform: null,
                    softVersion: "7.0.4",
                    sysVersion: "iOS 10.0.1",
                    token: "",
                },
                verifyCode: "",
                delogIS: false, //
                delogtitle: "兑换成功",
                delogdect: "请在万顺叫车顺风车-钱包中查看",
                content: "", //活动信息
            };
        },

        created() {
            window.getDataFromNative = this.getDataFromNative;
        },
        mounted() {
             //小程序
            if (this.$route.query.data) {
                let params = decodeURIComponent(this.$route.query.data);
                this.params = Object.assign({}, this.params, JSON.parse(params));
                let areaCode = this.params.areaCode;
                let cityCode = +(areaCode.slice(0, 4) + "00");
                this.params.cityCode = cityCode;
            } else {
                this.params = JSON.parse(this.$route.query.params); // 注释
                console.log(this.params)
            }
        },
        methods: {
            //APP交互后获取params
            getDataFromNative(params) {
                this.params = this.getParams(params);
                console.log("处理后的参数：" + this.params)
                let areaCode = this.params.areaCode;
                let cityCode = +(areaCode.slice(0, 4) + "00");
                this.params.cityCode = cityCode;
            },
            //APP交互处理params
            getParams(params) {
                if (mobileType.isIOS()) {
                    return params;
                } else if (mobileType.isAndroid()) {
                    return JSON.parse(params);
                }
            },
            async couponCode() {
                let params = {
                    ...this.params
                };
                params.data = {
                    verifyCode: this.verifyCode,
                };
                params.data = JSON.stringify(params.data);
                try {
                    const data = await getCouponCode(params);
                    if (data.code == 1) {
                        this.delogIS = true;
                        this.delogtitle = "兑换成功";
                        this.delogdect = "请到个人中心-万顺宝-优惠券-代驾券中查看";
                    } else {
                        this.delogIS = true;
                        this.delogtitle = "兑换失败";
                        this.delogdect = data.msg;
                    }
                    this.verifyCode = "";
                } catch (error) {}
            },
            exchange() {
                if (!this.verifyCode) {
                    this.$toast("请输入兑换码！");
                    return false;
                }
                this.couponCode();
            },
            close() {
                this.delogIS = false;
                this.verifyCode = "";
                if(this.delogtitle == '兑换成功') {
                    if (this.$route.query.isFrom && this.$route.query.isFrom == 'appMini') {
                        this.$router.back()
                    }else {
                        if (mobileType.isIOS()) {
                            window.ios.finish();
                        } else if (mobileType.isAndroid()) {
                            window.Android.finish();
                        }
                    }
                }
            }
        },
    };

</script>
<style lang="less" scoped>
    .container {
        padding-bottom: 20px;
        padding-top: 14px;
        background-repeat: no-repeat no-repeat;
        background: url('../../assets/img/exchange_bg.png') no-repeat no-repeat;
        background-size: 100% auto;
        background-color: #FFFDF9;
        .mian {
            width: 346px;
            background: #ffffff;
            box-shadow: 0px .01rem 12px 0px rgba(70, 205, 151, 0.16);
            border-radius: 16px;
            margin: 0 auto;
            margin-top: 58px;
            position: relative;
            text-align: center;
            padding-bottom: 32px;
            .box {
                .title {
                    text-align: center;
                    font-size: 18px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 600;
                    color: #252B3B;
                    line-height: 25px;
                    padding: 16px 0;
                }

                .inputBox {
                    width: 303px;
                    position: relative;
                    text-align: center;
                    margin: 0 auto;
                    margin-bottom: 20px;
                    input {
                        width: 270px;
                        font-size: 18px;
                        height: 54px;
                        border-radius: 8px;
                        padding: 0 14px;
                        border: 1px solid #DEDEDE;
                        color: #666;
                    }
                    input::placeholder{
                        color:#666;
                    }
                }

                .btn {
                    width: 303px;
                    height: 48px;
                    background: #252B3B;
                    border-radius: 10px;
                    font-size: 16px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #FFFFFF;
                    line-height: 48px;
                    text-align: center;
                    margin: 0 auto;
                }
            }
        }

        .rule {
            width: 314px;
            padding: 16px;
            margin: 0 auto;
            margin-top: 14px;
            background: #ffffff;
            box-shadow: 0px 0px 8px 0px rgba(96, 108, 133, 0.08);
            border-radius: .5rem;
            min-height: 5rem;
            color: #666;

            .title {
                font-size: 18px;
                font-weight: 600;
                color: #333333;
                text-align: center;
            }
            .rule_text {
                margin-top: 10px;
                font-size: 12px;
                li {
                    font-size: 12px;
                    line-height: 24px;
                }
            }
        }

        .delog {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.5);
            z-index: 999;

            .delogMain {
                position: absolute;
                top: 50%;
                left: 50%;
                background: #fff;
                transform: translate(-50%, -50%);
                text-align: center;
                width: 16.8rem;
                // height: 9.4rem;
                color: #333;
                border-radius: .5rem;
                margin: 0 auto;
                padding-bottom: .7rem;

                .delogtitle {
                    text-align: center;
                    font-size: .8rem;
                    color: #333330;
                    padding-top: 1.2rem;
                    font-weight: 600;
                }

                .dect {
                    font-size: .8rem;
                    font-weight: 400;
                    color: #333330;
                    line-height: 1rem;
                    margin: .5rem auto 1.2rem auto;
                    width: 10rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                }

                .delogBnt {
                    width: 15rem;
                    height: 2.4rem;
                    background: #252B3B;
                    border-radius: .5rem;
                    font-size: .8rem;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #FFFFFF;
                    line-height: 2.4rem;
                    text-align: center;
                    margin: 0 auto;
                }
            }
        }
    }

</style>
